import { atom, useAtom } from "jotai/index";
import { CalenderItem } from "@/types";

interface DataProps {
  date: string | null;
  hour: string | null;
  showDownload: boolean;
  requestedAlready: boolean;
  calendar: CalenderItem | null;
};

const defaultState: DataProps = {
  date: null,
  hour: null,
  showDownload: true,
  requestedAlready: false,
  calendar: null,
};

const diplomaRequestAtom = atom(defaultState);

export default function useDiplomaRequest() {
  const [diplomaRequest, setDiplomaRequest] = useAtom(diplomaRequestAtom);
  return {
    ...diplomaRequest,
    setState: (
      key: keyof DataProps,
      value: string | boolean | undefined | CalenderItem,
    ) => {
      setDiplomaRequest((prevState) => ({
        ...prevState,
        [key]: value,
      }));
    },
  };
}
